import axios from "axios";
import Config from "../../config/index";

import {
  CREATE_OPERATIONS_MACHINE_MAP_FAILURE,
  CREATE_OPERATIONS_MACHINE_MAP_REQUEST,
  CREATE_OPERATIONS_MACHINE_MAP_SUCCESS,
  DELETE_OPERATIONS_MACHINE_MAP_FAILURE,
  DELETE_OPERATIONS_MACHINE_MAP_REQUEST,
  DELETE_OPERATIONS_MACHINE_MAP_SUCCESS,
  GET_OPERATIONS_MACHINE_MAP_FAILURE,
  GET_OPERATIONS_MACHINE_MAP_REQUEST,
  GET_OPERATIONS_MACHINE_MAP_SUCCESS,
  UPDATE_OPERATIONS_MACHINE_MAP_FAILURE,
  UPDATE_OPERATIONS_MACHINE_MAP_REQUEST,
  UPDATE_OPERATIONS_MACHINE_MAP_SUCCESS,
} from "./operationsMachineMapTypes";

let baseUrl = Config.baseUrl;

const getOperationMachineMapRequest = () => {
  return {
    type: GET_OPERATIONS_MACHINE_MAP_REQUEST,
  };
};

const getOperationMachineMapSuccess = (payload) => {
  return {
    type: GET_OPERATIONS_MACHINE_MAP_SUCCESS,
    payload: payload,
  };
};

const getOperationMachineMapFailure = (error) => {
  return {
    type: GET_OPERATIONS_MACHINE_MAP_FAILURE,
    payload: error,
  };
};

const getOperationMachineMap = (pageNo, rowsPerPage, search, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };

  return (dispatch) => {
    dispatch(getOperationMachineMapRequest());

    // let url = `${baseUrl}/operation`;

    // /?page_number&rows_per_page&search&download
    let url = `${baseUrl}/operationMachineMap?page_number=${
      pageNo + 1
    }&rows_per_page=${rowsPerPage}&search=${search ? search : ""}`;

    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getOperationMachineMapSuccess(response?.data));
      })
      .catch((err) => {
        dispatch(getOperationMachineMapFailure(err.response));
      });
  };
};

// const getLabelsWithPaginationRequest = () => {
//   return {
//     type: GET_LABELS_WITH_PAGINATION_REQUEST,
//   };
// };

// const getLabelsWithPaginationSuccess = (payload) => {
//   return {
//     type: GET_LABELS_WITH_PAGINATION_SUCCESS,
//     payload: payload,
//   };
// };

// const getLabelsWithPaginationFailure = (error) => {
//   return {
//     type: GET_LABELS_WITH_PAGINATION_FAILURE,
//     payload: error,
//   };
// };

// const getLabelsWithPagination = (pageNo, rowsPerPage, search, jwtToken) => {
//   let headers = {
//     headers: {
//       Authorization: `Bearer ${jwtToken}`,
//     },
//   };

//   return (dispatch) => {
//     dispatch(getLabelsWithPaginationRequest());

//     let url = `${baseUrl}/label_size?page_number=${
//       pageNo + 1
//     }&rows_per_page=${rowsPerPage}&search=${search ? search : ""}`;

//     axios
//       .get(url, headers)
//       .then((response) => {
//         dispatch(getLabelsWithPaginationSuccess(response.data));
//       })
//       .catch((err) => {
//         dispatch(getLabelsWithPaginationFailure(err.response));
//       });
//   };
// };

const createOperationMachineMapRequest = () => {
  return {
    type: CREATE_OPERATIONS_MACHINE_MAP_REQUEST,
  };
};

const createOperationMachineMapSuccess = (payload) => {
  return {
    type: CREATE_OPERATIONS_MACHINE_MAP_SUCCESS,
    payload: payload,
  };
};

const createOperationMachineMapFaliure = (error) => {
  return {
    type: CREATE_OPERATIONS_MACHINE_MAP_FAILURE,
    payload: error,
  };
};

const createOperationMachineMap = (payload, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };

  return (dispatch) => {
    dispatch(createOperationMachineMapRequest());
    let url = `${baseUrl}/operationMachineMap`;

    return axios
      .post(url, payload, headers)
      .then((response) => {
        dispatch(createOperationMachineMapSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(createOperationMachineMapFaliure(err.response));
        return { status: false, data: err.response };
      });
  };
};

const updateOperationMachineMapRequest = () => {
  return {
    type: UPDATE_OPERATIONS_MACHINE_MAP_REQUEST,
  };
};

const updateOperationMachineMapSuccess = (payload) => {
  return {
    type: UPDATE_OPERATIONS_MACHINE_MAP_SUCCESS,
    payload: payload,
  };
};

const updateOperationMachineMapFaliure = (error) => {
  return {
    type: UPDATE_OPERATIONS_MACHINE_MAP_FAILURE,
    payload: error,
  };
};

const updateOperationMachineMap = (payload, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };

  return (dispatch) => {
    dispatch(updateOperationMachineMapRequest());
    let url = `${baseUrl}/operationMachineMap`;
    return axios
      .put(url, payload, headers)
      .then((response) => {
        dispatch(updateOperationMachineMapSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(updateOperationMachineMapFaliure(err.response));
        return { status: false, data: err.response };
      });
  };
};

const deleteOperationMachineMapRequest = () => {
  return {
    type: DELETE_OPERATIONS_MACHINE_MAP_REQUEST,
  };
};

const deleteOperationMachineMapSuccess = (payload) => {
  return {
    type: DELETE_OPERATIONS_MACHINE_MAP_SUCCESS,
    payload: payload,
  };
};

const deleteOperationMachineMapFaliure = (error) => {
  return {
    type: DELETE_OPERATIONS_MACHINE_MAP_FAILURE,
    payload: error,
  };
};

const deleteOperationMachineMap = (id, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };

  return (dispatch) => {
    dispatch(deleteOperationMachineMapRequest());
    let url = `${baseUrl}/operationMachineMap?operationMachineMapId=${id}`;

    return axios
      .delete(url, headers)
      .then((response) => {
        dispatch(deleteOperationMachineMapSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(deleteOperationMachineMapFaliure(err.response));
        return { status: false, data: err.response };
      });
  };
};

// const getPrintersForLabelCreationRequest = () => {
//   return {
//     type: GET_PRINTERS_FOR_LABEL_REQUEST,
//   };
// };

// const getPrintersForLabelCreationSuccess = (payload) => {
//   return {
//     type: GET_PRINTERS_FOR_LABEL_SUCCESS,
//     payload: payload,
//   };
// };

// const getPrintersForLabelCreationFailure = (error) => {
//   return {
//     type: GET_PRINTERS_FOR_LABEL_FAILURE,
//     payload: error,
//   };
// };

// const getPrintersForLabelCreation = (jwtToken) => {
//   let headers = {
//     headers: {
//       Authorization: `Bearer ${jwtToken}`,
//     },
//   };

//   return (dispatch) => {
//     dispatch(getPrintersForLabelCreationRequest());

//     let url = `${baseUrl}/asset/get_printer`;

//     axios
//       .get(url, headers)
//       .then((response) => {
//         dispatch(getPrintersForLabelCreationSuccess(response.data));
//       })
//       .catch((err) => {
//         dispatch(getPrintersForLabelCreationFailure(err.response));
//       });
//   };
// };

export {
  getOperationMachineMap,
  createOperationMachineMap,
  updateOperationMachineMap,
  deleteOperationMachineMap,
  //   getLabelsWithPagination,
  //   getPrintersForLabelCreation,
};
